import React from 'react'

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import StyledTextField from './StyledTextField'

import {
  capitalize
} from '../../helpers'

class FilterSelect extends React.Component {

  render() {
    const { name, label, onChange, filters, useBlank, collection, valueField, filter_type } = this.props
    return (
      <FormControl>
        {
          (filter_type === "search") ? (

            <StyledTextField
              value={filters[name] || ''}
              onChange={onChange(name)}
              inputProps={{
                name: name,
                id: `filters-${name}`,
              }}
              label="Search"
              placeholder={this.props.placeholders || ""}
              className={this.props.className || "filter-selects body2 c-black087 mr-24 no-sudo-hover filter-selects-search"}
            />
          ) : (
            <React.Fragment>
              <InputLabel className="body2 c-black087 form-select" htmlFor={`filters-${name}`}>{label || capitalize(name)}</InputLabel>
              <Select
                native
                value={filters[name] || ''}
                onChange={onChange(name)}
                inputProps={{
                  name: name,
                  id: `filters-${name}`,
                }}
                style={{
                  // minWidth: 110
                }}
                className="filter-selects body2 c-black087 mr-24 no-sudo-hover"
              >
                {
                  (useBlank !== false) && (<option value=""/>)
                }
                {
                  collection.map( item => {
                    if (typeof item === "string") {
                      return <option key={item} value={item}>{capitalize(item)}</option>
                    }
                    return(
                      <option key={item.longid || item.id} value={item.longid || item.id}>{item[valueField]}</option>
                    )
                  })
                }
              </Select>
            </React.Fragment>
          )
        }

      </FormControl>
    )
  }
}

export default FilterSelect



// WEBPACK FOOTER //
// ./src/js/components/inputs/FilterSelect.js